"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'dblogs.col.model': 'Modelo',
    'dblogs.col.operation': 'Operación',
    'dblogs.col.recordId': 'ID de registro',
    'dblogs.col.date': 'Fecha',
    'dblogs.col.payload': 'Datos',
    'dblogs.col.result': 'Resultado',
};
